import css from 'styled-jsx/css';

const styles = css.global`#renegociacao25-parceiros {
  background:#444;
  padding: 40px 0;
  overflow: hidden;
}

#renegociacao25-parceiros .ctn-home-24 {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

#renegociacao25-parceiros .parceiros-textos {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

#renegociacao25-parceiros .parceiros-textos .parceiros-titulo {
  color: #FFF;
  font-family: "SantanderHeadline";
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}

#renegociacao25-parceiros .parceiros-textos .parceiros-texto {
  color: #FFF;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
}

#renegociacao25-parceiros .parceiros-carrossel .slide {
  display: flex;
  width: 163px;
  height: 127px;
  align-items: center;
  justify-content: center;
  background: #FFF;
  margin-right: 24px;
  flex: 0 0 163px;
  padding: 24px;
}

#renegociacao25-parceiros .parceiros-carrossel .slide img {
  width: 100%;
}

#renegociacao25-parceiros .parceiros-carrossel .home-pagination {
  margin-top: 24px;
}

#renegociacao25-parceiros .home-pagination .embla__prev {
  background-image: url(assets/renegociacao25/vantagens/arrow_l.svg);
}

#renegociacao25-parceiros .home-pagination .embla__next {
  background-image: url(assets/renegociacao25/vantagens/arrow_r.svg);
}

#renegociacao25-parceiros .home-pagination .embla__prev, 
#renegociacao25-parceiros .home-pagination .embla__next {
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
}


@media (min-width: 992px) {
  #renegociacao25-parceiros .parceiros-textos {
    gap: 16px;
  }
  #renegociacao25-parceiros .parceiros-carrossel{
    overflow: hidden;
  }
}`;

export default styles;